import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import qs from 'query-string';

import { addError } from '@actions/appState';

import { getCurrentAgency } from '@utils/AuthUtil';

interface ILogoutCallbackProps extends RouteComponentProps<{}> {
  addError: TAddError;
}
class LogoutCallback extends React.PureComponent<ILogoutCallbackProps> {
  componentDidMount() {
    this.redirectToLogin();
    const queryParams = qs.parse(this.props.location.search);
    if (queryParams.state) {
      this.redirectToError(queryParams.state);
    }
  }

  redirectToError = async (state?: string) => {
    const agency = getCurrentAgency();

    if (state === LOGIN_ERROR_STATE.OAUTH_USER_HAVE_NO_PRIVELEGES) {
      return;
    }

    if (state !== LOGIN_ERROR_STATE.OAUTH_SILENT_ERROR_STATE) {
      return;
    }
    if (state !== LOGIN_ERROR_STATE.OAUTH_SILENT_ERROR_STATE) {
      this.props.addError(state);
    }
    this.props.history.push(`/agencies/${agency.id}/error`);
  };

  redirectToLogin = async () => {
    const agency = getCurrentAgency();
    this.props.history.push(`/agencies/${agency.id}/login`);
  };

  render() {
    return <h1 className={classnames('redirection-message')}>Wait while we redirect you back to login page</h1>;
  }
}
const mapStateToProps = (state: IReduxStore) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  addError: (errorMessage: string) => dispatch(addError(errorMessage)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoutCallback));
